import { Directive, ElementRef, HostListener, Optional } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[appForceUppercase]',
})
export default class ForceUppercaseDirective {
  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    @Optional() private ngControl?: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const input = this.elementRef.nativeElement
    const originalValue = input.value ?? ''
    const uppercasedValue = originalValue.toUpperCase()

    if (uppercasedValue === originalValue) {
      return
    }

    const {selectionStart, selectionEnd} = input
    const control = this.ngControl?.control

    input.value = uppercasedValue

    if (control) {
      control.setValue(uppercasedValue, { emitEvent: false })
    }

    if (selectionStart !== null && selectionEnd !== null) {
      input.setSelectionRange(selectionStart, selectionEnd)
    }
  }
}
